import template from './sw-category-seo-form.html.twig';

const { Component } = Shopware;
const { Criteria } = Shopware.Data;

Component.override('sw-category-seo-form', {
    template,

    inject: [ 'repositoryFactory' ],

    data() {
        return {
            salesChannelDomainRepository: null,
            salesChannel: "",
            configRepository: null,
            maxMetaTitle: 60,
            maxMetaDescription: 160,
            metaTitleColor: null,
            metaDescriptionColor: null
        };
    },

    created() {
        this.salesChannelDomainRepository = this.repositoryFactory.create('sales_channel_domain');
        this.configRepository = this.repositoryFactory.create('system_config');
        const configCriteria = new Criteria();
        configCriteria.addFilter(Criteria.contains('configurationKey', 'HuebertSeoUltimate.config.meta'));
        this.configRepository.search(configCriteria, Shopware.Context.api)
            .then((entity) => {
                entity.forEach((entry) => {
                    if(entry.configurationKey === 'HuebertSeoUltimate.config.metaTitleCounter' && entry.salesChannelId == null) {
                        this.maxMetaTitle = entry.configurationValue;
                    } else if (entry.configurationKey === 'HuebertSeoUltimate.config.metaDescriptionCounter' && entry.salesChannelId == null) {
                        this.maxMetaDescription = entry.configurationValue;
                    }
                });
            });
    },

    computed: {
        metaTitleCount: function () {
            let charCount = 0;
            if(this.category.metaTitle) {
                charCount =  this.category.metaTitle.length;
            }
            this.metaTitleColor = charCount > this.maxMetaTitle;
            const counterString = ' (' + charCount + '/' + this.maxMetaTitle + ')';
            return counterString;
        },
        metaDescriptionCount: function () {
            let charCount = 0;
            if(this.category.metaDescription) {
                charCount =  this.category.metaDescription.length;
            }
            this.metaDescriptionColor = charCount > this.maxMetaDescription;
            const counterString = ' (' + charCount + '/' + this.maxMetaDescription + ')';
            return counterString;
        },
        seoUrl: function () {
            let urlString;
            if(this.category['seoUrls'][0]) {
                this.createSalesChannel();
                const seoPathInfo = this.category['seoUrls'][0]['seoPathInfo'];
                const pathInfo = this.category['seoUrls'][0]['pathInfo'];
                if(seoPathInfo) {
                    urlString = this.salesChannel + '/' + seoPathInfo;
                } else {
                    urlString = this.salesChannel + '/' + pathInfo;
                }
            } else {
                urlString = this.$tc('hueb-seo.general.placeholderNoUrl')
            }
            return urlString;
        }
    },

    methods: {
        createSalesChannel() {
            const channelCriteria = new Criteria();
            channelCriteria.addFilter(Criteria.equals('salesChannelId', this.category['seoUrls'][0]['salesChannelId']));

            this.salesChannelDomainRepository.search(channelCriteria, Shopware.Context.api)
                .then((entity) => {
                    if(entity.length) {
                        //this.salesChannel = entity[0].url;
                        entity.forEach((entry) => {
                           if(entry.languageId === Shopware.Context.api.languageId && this.salesChannel !== entry.url) {
                               this.salesChannel = entry.url;
                           }
                        });
                        if(this.salesChannel === "") {
                            this.salesChannel = entity[0].url;
                        }
                    }
                });
        }
    }
});
